export default __webpack_public_path__ + "static/media/milestone2.09cc5da7.png";